import { Sparkles } from '~/ui'

import { useThemeCustomizerContext } from './theme-customizer-context'

type ThemeCustomizerTriggerProps = Omit<
  React.ComponentPropsWithoutRef<'button'>,
  'children'
>

export const ThemeCustomizerTrigger = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...props
}: ThemeCustomizerTriggerProps) => {
  const { setIsOpen } = useThemeCustomizerContext()

  return (
    <button
      className="cursor-pointer"
      onClick={(e) => {
        onClick?.(e)
        if (e.defaultPrevented) return

        setIsOpen((v) => !v)
      }}
      {...props}
    >
      <Sparkles className="size-6" />
    </button>
  )
}
